import { render } from "./UpdateStores.vue?vue&type=template&id=6d5c12a9"
import script from "./UpdateStores.vue?vue&type=script&lang=js"
export * from "./UpdateStores.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__